export const alignment = {
  excludes: 'alignment indentation',
  group: 'alignment',
  attrs: {
    align: {}
  },
  parseDOM: [{
    tag: 'div.fabric-editor-block-mark',
    getAttrs: dom => {
      const align = dom.getAttribute('data-align');
      return align ? {
        align
      } : false;
    }
  }],
  toDOM(mark) {
    return ['div', {
      class: "fabric-editor-block-mark fabric-editor-align-".concat(mark.attrs.align),
      'data-align': mark.attrs.align
    }, 0];
  }
};